export default {
	share_add_users: 'Add people or groups',
	share_chain_show_less: 'Show less',
	share_chain_show_more: 'Show all',
	share_chain_write_message: 'Write message',
	share_chip_shared_by: 'Shared by {name}',
	share_dialog_close: 'Apply',
	share_message_label: 'Message to recipients (optional)',
	share_not_shared: 'Not shared',
	share_remove_user: 'Remove {name}',
	share_reshared: 'Shared with you & reshared',
	share_shared: 'Shared',
	share_shared_by_others: 'Shared by others',
	share_shared_by_you: 'Shared by you',
	share_sharing: 'Share',
	share_sheet_change_added: '{n} added',
	share_sheet_change_message: 'message changed',
	share_sheet_change_removed: '{n} removed',
	share_sheet_discard: 'Discard',
	share_sheet_discard_message: 'These changes will not be saved: {changes}.',
	share_sheet_discard_title: 'Discard changes?',
	share_sheet_edit_message: 'Edit message',
	share_sheet_folded_unfold: 'Show message',
	share_sheet_group_member_count: '{n} person | {n} people',
	share_sheet_keep_editing: 'Keep editing',
	share_sheet_message_heading: 'Message to recipients',
	share_sheet_message_placeholder: 'Add a message (optional)',
	share_sheet_row_new: 'New',
	share_sheet_search_no_results: 'No people or groups found',
	share_sheet_search_placeholder: 'Search people or groups',
	share_sheet_section_groups: 'Groups',
	share_sheet_section_people: 'People',
	share_sheet_section_selected: 'Selected',
	share_sheet_title: 'Share: {title}',
	share_status_ready: 'Done',
	share_status_seen: 'In progress',
	share_status_unseen: 'Unseen',
};
